import React from 'react';
import {Link} from 'react-router-dom';
import LaddaButton, {XL, EXPAND_LEFT} from 'react-ladda';
import {toastr} from 'react-redux-toastr';
import {User} from 'api';
import isEmpty from 'lodash/isEmpty';
import _ForgotPasswordForm from './_ForgotPasswordForm.scss';

class ForgotPasswordForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      email: '',
      isSubmit: false
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  onSubmit(e) {
    e.preventDefault();
    if (!isEmpty(this.state.email)) {
      const data = {
        email: this.state.email
      };
      this.setState({isSubmit: true});
      User.actions.requestPassword.request({}, {data}).then((response) => {
        this.setState({isSubmit: false, email: ''});
        toastr.success('Thành công', 'Email đã được gửi đi, vui lòng kiểm tra email của bạn.');
      }).catch((error) => {
        this.setState({isSubmit: false});
        toastr.error('Lỗi!', 'Không thể khôi phục mật khẩu.');
      });
    } else {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin.');
    }
  }

  render() {
    const {email, isSubmit} = this.state;
    return (
      <section className="restore-wrapper-D">
        <h2 className="restore-title">Khôi phục mật khẩu</h2>
        <form className="restore-form" onSubmit={this.onSubmit}>
          <div className="restore-input-group">
            <i className="fa fa-at restore-icon"/>
            <input className="restore-input" onChange={this.onChange} name="email" value={email} placeholder="Nhập email đăng kí..."/>
          </div>
          <LaddaButton className="restore-btn" type="submit" data-size={XL} data-style={EXPAND_LEFT} loading={isSubmit}>Cấp lại mật khẩu</LaddaButton>
        </form>
        <p className="restore-to-register">
          Bạn chưa có tài khoản?&nbsp;
          <Link className="register-link" to="/signup">Đăng kí ngay</Link>
        </p>
      </section>
    );
  }
}

export default ForgotPasswordForm;



// WEBPACK FOOTER //
// ./components/forgotpassword/ForgotPasswordForm.jsx